import { SimpleGrid } from "@chakra-ui/react";
import { CaseStudyCard } from "./Components/CaseStudyCard";
import caseStudies from "./Data/caseStudies.json"
import TechLayout from "./TechLayout";


export const CaseStudyList = () => {
  return (
    <TechLayout>
<SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
  {caseStudies.map((study) => (
    <CaseStudyCard key={study.id} id={study.id} />
  ))}
</SimpleGrid>
    </TechLayout>
  );
};